<div class="tab-pane" role="tabpanel" id="informe_revisor">
    <fieldset id="agregar_informe_revisor" class="">
        <div class="step_section">

            <div class="row" id="row">

                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group">
                                <label class="col-md-3" align="left" style="padding-bottom: 10px; padding-top: 20px" for="infradio">Cuenta con informe de revisor de c&aacute;lculo estructural:</label>
                                <div class="col-md-2" class="inline">
                                    <mat-radio-group formControlName="infradio" (change)="add_informe_revisor()" style="padding-left: 15px;">
                                        <mat-radio-button style="padding-right: 40px; padding-top: 20px" name="infradio" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 25px; padding-top: 20px" name="infradio" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>

                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-3 control-label" style=" padding-top: 15px; text-align:left" for="num_informe_revisor">Numero informe</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Numero informe" id="num_informe" name="num_informe" formControlName="num_informe" (change)="add_informe_revisor()" [errorStateMatcher]="matcher">

                                        <mat-error *ngIf="form.controls['num_informe'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error> 
                                        <mat-error *ngIf="form.controls?.num_informe.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-3 control-label" style=" padding-top: 15px; text-align:left" for="fech_informe_revisor_revisor">Fecha informe</label>
                                <div class="col-md-2">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp3" [max]="maxDate" formControlName="fecha_informe" (dateInput)="add_informe_revisor()" (dateChange)="add_informe_revisor()">
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>